import { CallActions } from '../../../../store/call/actions';
import { AppThunk } from '../../../../store/types';
import { CallAppEffects } from '../../hocs/events';

export class CallLangMenuListEvents {

	public static onChange (
		lang: string,
	): AppThunk<Promise<void>> {
		return (
			dispatch,
			getState
		) => {
			return lang ? CallAppEffects.setLang(lang) : Promise.resolve();
		}
	}
}
